module.exports = __webpack_public_path__ + "media/images/docs-320319a6a26e1008d15f4b1d6f3450c3.png";